export const COUNTRIES_META = {
    IN: { NAME: "India", DIAL_CODE: "+91", CODE: "IN" },
    NP: { NAME: "Nepal", DIAL_CODE: "+977", CODE: "NP" },
    LK: { NAME: "Sri Lanka", DIAL_CODE: "+94", CODE: "LK" },
  };
